module.exports = __webpack_public_path__ + "img/privacy.e99139bb.jpg";